import { AppState } from 'store/store';

export const auditLogsSelector = (state: AppState) => state.reports.auditLog;
export const schoolStatSelector = (state: AppState) => state.reports.schoolStat;
export const otherCommuneStatSelector = (state: AppState) => state.reports.otherCommune;
export const otherCommuneStudentsSelector = (state: AppState) => state.reports.otherCommune.students;
export const subventionFactorsSelector = (state: AppState) => state.reports.subventionFactors;
export const synchronizationLogSelector = (state: AppState) => state.reports.syncLog;
export const synchronizationLogListFiltersSelector = (state: AppState) => state.reports.syncLog.filters;
export const personalDataAccessListSelector = (state: AppState) => state.reports.personalDataAccess;
export const personalDataAccessStudentsListSelector = (state: AppState) => state.reports.personalDataAccessStudents;
export const personalDataChangeRegisterListSelector = (state: AppState) => state.reports.changePersonalDataRegister;
export const userPersonalDataChangeRegisterListSelector = (state: AppState) =>
  state.reports.userPersonalDataChangeRegister;
export const dataChangeRegisterListSelector = (state: AppState) => state.reports.changePersonalDataRegister;
